import { useTranslations } from "next-intl";

import Button from "~/components/common/button";
import styles from "~/components/guest-track-your-order/guest-track-your-order.module.scss";
import GuestOrderDetail from "~/components/myaccount/orders/guest-order-detail";

export default function GuestTrackYourOrderStep2(props: { onPrev: () => void }) {
  const t = useTranslations();

  return (
    <>
      <div className={styles.centered}>
        <Button variant="primary" className={styles.button} onClick={props.onPrev} type="button">
          {t("generic.back")}
        </Button>
      </div>
      <GuestOrderDetail></GuestOrderDetail>
    </>
  );
}
